import React from 'react'
import ReactDOM from 'react-dom'
import reportWebVitals from 'reportWebVitals'
import { App } from 'App'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { Provider } from 'react-redux'
import store from 'store/store'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
const queryClient = new QueryClient()

ReactDOM.render(
	// Don't remove Strict mode to detect more potential bugs
	<QueryClientProvider client={queryClient}>
		<React.StrictMode>
			<Provider store={store}>
				<App />
			</Provider>
		</React.StrictMode>
		<ReactQueryDevtools initialIsOpen={false} />
	</QueryClientProvider>,
	document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
